import React from 'react';
import { MdOutlineDomain, MdOutlineHome } from 'react-icons/md'

import { EConstructionType } from '../../../types-library/src'
import { useFilterStore } from '../../../state-library/src'

const apartmentOptions: { code: string | undefined; icon: string }[] = [
  {
    code: 'house',
    icon: 'home',
  },
  {
    code: 'apartment',
    icon: 'domain',
  },
]

const ConstructionTypeFilter = () => {
  const { constructionType, setConstructionType } = useFilterStore()
  const changeOptions = (code: string | undefined): void => {
    if (constructionType === code) {
      return
    }

    if (constructionType === undefined) {
      if (code === EConstructionType.APARTMENT) {
        setConstructionType(EConstructionType.HOUSE)
      } else if (code === EConstructionType.HOUSE) {
        setConstructionType(EConstructionType.APARTMENT)
      }
      return
    }

    setConstructionType(undefined)
  }

  return (
    <div className="flex gap-2">
      {apartmentOptions.map(({ code, icon }) => {
        return (
          <button
            type="button"
            key={code}
            onClick={() => changeOptions(code)}
            className={`w-[42px] h-[42px] flex justify-center items-center rounded-lg active:scale-95 duration-100 
            ${
              constructionType === code || constructionType === undefined
                ? 'bg-[rgba(3,104,254,0.10)] border-2 border-blue'
                : 'bg-[rgba(72,74,94,0.10)]'
            }
            `}
          >
            {icon === 'home' ? (
              <MdOutlineHome
                className={`w-6 h-6 ${
                  constructionType === code || constructionType === undefined
                    ? 'fill-blue'
                    : 'fill-primary'
                }`}
              />
            ) : (
              <MdOutlineDomain
                className={`w-6 h-6 ${
                  constructionType === code || constructionType === undefined
                    ? 'fill-blue'
                    : 'fill-text-primary'
                }`}
              />
            )}
          </button>
        )
      })}
    </div>
  )
}

export default ConstructionTypeFilter
